<template>
    <div>
        <div class="search-box">
            <p>学期：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.semesterCode">
                <a-select-option v-for="(item,index) in xqArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>姓名：</p>
            <a-input class="input-box" v-model="searchFrom.teacherName" />
            <p>级别：</p>
            <a-select 
                class="input-box" 
                allowClear 
                v-model="searchFrom.teachFaultLevelCode">
                <a-select-option v-for="(item,index) in jbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
            <!-- <a-button type="primary" icon="plus" class="right-btn" @click="$refs.info.showDrawer('新增','')">新增</a-button> -->
        </div>
        <div class="operation-box">
            <a-button type="primary" v-if="permissions.indexOf('undergraduate:culture:accident:add')>-1" icon="plus" class="btn" @click="$refs.info.showDrawer('新增','')">新增</a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="selectedRowKeys[0] == null ? selectedCheck() :remove(selectedRowKeys[0])">
                <a-button 
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    v-if="permissions.indexOf('undergraduate:culture:accident:delete')>-1">
                    删除
                </a-button>
            </a-popconfirm>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() :$refs.info.showDrawer('编辑',selectedRowKeys[0])"
                v-if="permissions.indexOf('undergraduate:culture:accident:edit')>-1">
                 修改
            </a-button>
            <a-button type="primary" class="btn" icon="file-search" v-if="permissions.indexOf('undergraduate:culture:accident:query')>-1" @click="selectedRowKeys[0] == null ? selectedCheck() :$refs.info.showDrawer('查看',selectedRowKeys[0])" >查看详情</a-button>
        </div>
        <a-table 
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: '100%' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
            <template slot="teachFaultLevelCode" slot-scope="text,record">
                <a-select class="show-input" v-model="record.teachFaultLevelCode" disabled>
                    <a-select-option v-for="(item,index) in jbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </template>
            <!-- <template slot="id" slot-scope="text">
                <a class="action-btn" @click="$refs.info.showDrawer('查看',text)">详情</a>
                <a-divider type="vertical" />
                <a class="action-btn" @click="$refs.info.showDrawer('编辑',text)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(text)"
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template> -->
        </a-table>
        <info ref="info"></info>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del } from '@/baseAPI/undergraduate/culture/accident'
    import Info from '../culture/modules/accidentInfo'
    import { selectedCheck } from '@/baseAPI/util'

    const columns = [
        {
            title: '序号',
            dataIndex: 'id',
            align:'center',
            width:70,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '学期',
            dataIndex: 'semesterName',
            align:'center',
        },
        {
            title: '姓名',
            dataIndex: 'teacherName',
            align:'center'
        },
        {
            title: '级别',
            dataIndex: 'teachFaultLevelCode',
            align:'center',
            scopedSlots: { customRender: 'teachFaultLevelCode' }
        },

    ];
    export default {
        name: 'teacher',
        components: {
            Info
        },
        data () {
            return {
                selectedRowKeys: [],
                permissions:[],
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 0,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    teacherName:'',
                    teachFaultLevelCode:'',
                    semesterCode:'',
                },
                jbArr:[],
                xqArr:[],
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;

            getDicts({dataCode:'JXGSJB',status:true}).then(res=>{
                this.jbArr=res.data.dicts;
            })
            getDicts({dataCode:'XQ',status:true}).then(res=>{
                this.xqArr=res.data.dicts;
            })
            this.fetch()
        },
        methods:{
            selectedCheck(){
                selectedCheck()
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 13rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }

</style>
